import { Alpine, AsyncAlpine } from "./main.alpinejs.js";
import { initPinchZoomOnLoad } from './modules/pinchToZoom/pinch-to-zoom.js';
import "./main.data.js";
import "./modules/footnoteRef/index.js";

initPinchZoomOnLoad();

AsyncAlpine.start();
Alpine.start();
